import { Modal, Input, Checkbox, Row, Col, Form, Card, Space, Select } from "antd";
import {AxiosError} from "axios"
import { displayMessage } from "../../services/helper";
import { useEffect, useState } from "react";
import SL_Button from "../buttons/Button";
import ProtocolExercisesModal from "./ProtocolExercisesModal";
import { MultiSelect } from "../selects/MultiSelect";
import api from "../../services/api";
import EDaysOfTheWeek from "../../enums/EDaysOfTheWeek"
import ELanguages from "../../enums/ELanguages"
import { getLanguageOnLocalstorage } from "../../services/helper";
const daysOfWeek = Object.values(EDaysOfTheWeek ?? {}).map((day)=>{
  return {
    label: day.label,
    value: day.code,
  }
}) ?? []

const {Option} = Select
const AddPatientProtocolModal = ({
  isPatientProtocolModalOpen,
  setIsPatientProtocolModalOpen,
  patientId,
  loadPatientProtocols,
}) => {
  const [protocol, setProtocol] = useState([]);
  const [scheduledDays, setScheduledDays] = useState([]);
  const [isProtocolExerciseModalOpen, setIsProtocolExerciseModalOpen] =
    useState(false);

    const [language, setLanguage] = useState([]);
  const handleSubmit = async () => {
    try {
      const payload = {
        protocol: protocol,
        scheduledDays,
      };
      await api.patient_protocol.createPatientProtocol(patientId.id, payload);
      setIsPatientProtocolModalOpen(false);
      loadPatientProtocols();
      alert(displayMessage("CREATED_PROTOCOL_SUCCESS"), "success");
    } catch (error) {
      if (error?.response?.data?.error && error instanceof AxiosError){
        alert(error?.response?.data?.error, "error")
        return
      }
      alert(displayMessage("CREATED_PROTOCOL_ERROR"), "error");
    }
  };
  const mountProtocolOptions = async (e) => {
    try {     
      const { data } = await api.protocols.listProtocolsByTarget({ value: e, language: language.code ?? ELanguages.PORTUGUESE.code });
      return data.map((protocol) => ({
        label: protocol?.name,
        value: protocol?.id,
        key: protocol?.scheduleDays ?? []
      }));
    } catch (error) {
      console.error(error);
    }
  };
  
  const handleOnExerciseProtocolOpen = () => {
    setIsProtocolExerciseModalOpen(true);
  };

  return (
    <>
      {isProtocolExerciseModalOpen && (
        <ProtocolExercisesModal
          protocolId={protocol}
          isPatientProtocolModalOpen={isProtocolExerciseModalOpen}
          setIsPatientProtocolModalOpen={setIsProtocolExerciseModalOpen}
        />
      )}
      <Modal
        visible={isPatientProtocolModalOpen}
        onCancel={() => setIsPatientProtocolModalOpen(false)}
        title={
          <div className="text-xl font-bold">
            {displayMessage("ADD_PROTOCOLS")}
          </div>
        }
        footer={null}
        width={600}
        className="p-6"
      >
        <Form layout="vertical" className="gap-5">
        <Form.Item
            label={
              <span className="text-base font-medium">
                {displayMessage("LANGUAGE")}
              </span>
            }
          >

<Select
onChange={(code) => {
  const selected = Object.values(ELanguages).find(lang => lang.code === code);
  setLanguage(selected);
  setProtocol([]);
  setScheduledDays([]);
}}
  value={language.code}
  placeholder={displayMessage('LANGUAGE')}
>
  {Object.values(ELanguages).map((type) => (
    <Option key={type.code} value={type.code}>
      {type.description}
    </Option>
  ))}
</Select>
          </Form.Item>
          <Form.Item
            label={
              <span className="text-base font-medium">
                {displayMessage("DESCRIPTION")}
              </span>
            }
          >
            <Row gutter={12}>
              <Col flex="auto">
                <MultiSelect
                  allowClear
                  fetchOptions={mountProtocolOptions}
                  placeholder={displayMessage("ADD_PROTOCOL")}
                  value={protocol}
                  mode="single"
                  onChange={(value) => {
                    setProtocol(value)
                    setScheduledDays(value.key)
                  }}
                />
              </Col>
              <Col>
                  <SL_Button onClick={handleOnExerciseProtocolOpen}>
                    {displayMessage("LIST_EXERCISES")}
                  </SL_Button>        
              </Col>
            </Row>
          </Form.Item>

          <Form.Item
            label={
              <span className="text-base font-medium">
                {displayMessage("SCHEDULE_DAYS")}
              </span>
            }
          >
            <Card className="rounded-xl border border-gray-200 bg-gray-50 p-5">
              <Row gutter={[16, 12]}>
                {daysOfWeek.map((day) => (
                  <Col xs={24} sm={12} key={day.value}>
                    <div
                      className={`p-3 px-4 rounded-lg border-2 cursor-pointer transition-all duration-300 flex items-center gap-2 ${
                        scheduledDays.includes(day.value)
                          ? "border-blue-500 bg-blue-50"
                          : "border-gray-200 bg-white"
                      }`}
                      onClick={() => {
                        setScheduledDays((prev) =>
                          prev.includes(day.value)
                            ? prev.filter((val) => val !== day.value)
                            : [...prev, day.value]
                        );
                      }}
                    >
                      <Checkbox
                        value={day.value}
                        checked={scheduledDays.includes(day.value)}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setScheduledDays((prev) =>
                            checked
                              ? [...prev, day.value]
                              : prev.filter((val) => val !== day.value)
                          );
                        }}
                        className="pointer-events-none"
                      />
                      <span
                        className={`text-sm ${
                          scheduledDays.includes(day.value)
                            ? "font-medium text-blue-500"
                            : "font-normal text-gray-800"
                        }`}
                      >
                        {day.label}
                      </span>
                    </div>
                  </Col>
                ))}
              </Row>
            </Card>
          </Form.Item>

          <Form.Item className="mt-8 mb-0">
            <Space className="w-full">
              <SL_Button onClick={() => setIsPatientProtocolModalOpen(false)}>
                Cancelar
              </SL_Button>
              <SL_Button onClick={handleSubmit}>
                {displayMessage("REGISTER")}
              </SL_Button>
            </Space>
          </Form.Item>
        </Form>
      </Modal>
      
    </>
  );
};

export default AddPatientProtocolModal;